import { UseCasesLanding } from "@/features/use-cases/components/landing/use-cases-landing"

export function UseCasesPage() {
  return <UseCasesLanding />
}
